/**
 * imageVariants.js — convert a canonical image URL into a smaller
 * pre-generated variant (200 / 400 / 800 px WebP) when the image lives
 * in AG7's object storage.
 *
 * URLs served by our storage look like:
 *     /api/files/ag7-store/kind/owner/uuid.webp
 * The backend `put_image_optimized(..., make_variants=True)` uploads three
 * WebP siblings next to it:
 *     .../uuid_200.webp
 *     .../uuid_400.webp
 *     .../uuid_800.webp
 *
 * External URLs (Cloudinary, CDNs, admin-pasted links) pass through
 * unchanged so we never break a working image.
 */

const AG7_STORAGE_HOSTS = ["/api/files/", "/api/uploads/"];

/**
 * Return the ``size`` variant of ``url`` when possible, else the original.
 * ``size`` must be one of "200", "400", "800".
 */
export function variantUrl(url, size = "400") {
  if (!url || typeof url !== "string") return url;
  const isOurStorage = AG7_STORAGE_HOSTS.some((h) => url.includes(h));
  if (!isOurStorage) return url;
  // Only rewrite when the URL ends in a known image extension we control.
  const m = url.match(/^(.*)\.(webp|jpg|jpeg|png)(\?.*)?$/i);
  if (!m) return url;
  const [, base, , qs] = m;
  return `${base}_${size}.webp${qs || ""}`;
}

/** Convenience alias for card thumbnails on mobile. */
export const thumb200 = (url) => variantUrl(url, "200");
export const thumb400 = (url) => variantUrl(url, "400");
export const thumb800 = (url) => variantUrl(url, "800");
